import { OnboardingContentWrapper } from "components/Docs/OnboardingContentWrapper";
import { EmbeddingEvent } from "onboarding/llm-analytics/_snippets/embedding-event.tsx";
import * as React from 'react';
export default {
  OnboardingContentWrapper,
  EmbeddingEvent,
  React
};